import { DateTime } from 'luxon';
import {
  useHeaderTitle,
  useHeaderTitleEnabled,
} from '@/features/experiences/contexts/PageExperienceContext';
import { FONT_HEADING } from '@/features/printables/css/customFonts';
import type { Month } from '../types';

type Props = {
  month: Month;
  pageIndex: number;
  pageIndexForMonth: number;
};

export const PageHeader = ({ month, pageIndex, pageIndexForMonth }: Props) => {
  const headerTitle = useHeaderTitle();
  const headerTitleEnabled = useHeaderTitleEnabled();
  const monthLabel = DateTime.fromObject({
    month: month.month,
    year: month.year,
  }).toFormat('LLLL yyyy');
  const pageNumber =
    pageIndexForMonth > 0 ? ` (Page ${pageIndexForMonth + 1})` : '';

  return (
    <div
      data-measure={`page-${pageIndex}-header`}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: 10,
      }}
    >
      {headerTitleEnabled && (
        <h1
          style={{
            fontSize: '2em',
            fontWeight: '700',
            fontFamily: FONT_HEADING,
            marginBottom: '0.25em',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {headerTitle || <>&nbsp;</>}
        </h1>
      )}
      <span
        style={{
          fontSize: '1.25em',
          fontWeight: '400',
          fontFamily: FONT_HEADING,
          flexShrink: 0,
          marginLeft: '1em',
        }}
      >
        {monthLabel}
        {pageNumber}
      </span>
    </div>
  );
};
